// extracted by mini-css-extract-plugin
module.exports = {"confirmButton":"banks_confirmButton__xvR1P","cancelButton":"banks_cancelButton__s2QkC"};